/* eslint-disable */

import React, { useState, useCallback, useEffect } from "react";
import { Query, Builder, Utils as QbUtils } from "@react-awesome-query-builder/mui";
import { MuiConfig } from "@react-awesome-query-builder/mui";
import "./css/compact_styles.scss";
import "./css/styles.scss";
import { useSelector } from "react-redux";
import { languagesOptions } from "../../../js/constants/selectOptions";
import {
    Box,
    Chip,
    Divider,
    FormHelperText,
    Grid,
    ListItem,
    ListItemText,
    Typography,
    TextField,
    Autocomplete,
} from "@mui/material";
import { ScreenLoading } from "../../Widgets/CustomLoadings";
import { useAxiosConfig } from "../../../js/utils/customHooks";
import Axios from "axios";
import { fetchData } from "../../../js/utils/backend";
import { useFormContext } from "react-hook-form";
import { HiddenField } from "../../Widgets/Custom Inputs/CustomInputs";
import { t, Translate } from "react-i18nify";
import { regexGuid } from "../../../js/utils/inputValidations";
import { mainRed } from "../../../themes/GlobalTheme";

/* This css will go further by applying a custom colors on buttons */
const muiTheme = {
    palette: {
        primary: {
            main: `${mainRed}`,
            light: "#000000",
            dark: "#000000",
            contrastText: "#eeeeee",
        },
        secondary: {
            main: `${mainRed}`,
            light: "#000000",
            dark: "#000000",
            contrastText: "#eeeeee",
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    borderRadius: 24,
                    "&:hover": {
                        color: mainRed,
                        backgroundColor: "#F7F9FA",
                    },
                },
                contained: {},
                containedNeutral: {
                    backgroundColor: "#A8A8A8", //"rgba(135, 154, 162, 0.6)",
                },
                text: {
                    color: mainRed,
                },
            },
        },
    },
};

/** Config per type of field for the query builder  */
const frontFieldToQueryField = (frontField, token) => {
    const getDateFormatFromBrowser = () => {
        return navigator.language.startsWith('en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    };
    switch (frontField.FieldType) {
        case "Text":
            return [
                frontField.Fieldname,
                {
                    label: frontField.Label,
                    type: "text",
                    operators: [
                        "equal",
                        "not_equal",
                        "like",
                        "not_like",
                        "is_empty",
                        "is_not_empty",
                        "is_null",
                        "is_not_null",
                    ],
                    tooltip: frontField.Description,
                    valueSources: ["value"],
                },
            ];
        case "Float":
            return [
                frontField.Fieldname,
                {
                    label: frontField.Label,
                    type: "number",
                    fieldSettings: {
                        min: frontField.MinValue,
                        max: frontField.MaxValue,
                        step: 0.0000001,
                    },
                    valueSources: ["value"],
                    preferWidgets: ["number"],
                    tooltip: frontField.Description,
                },
            ];
        case "Integer":
            return [
                frontField.Fieldname,
                {
                    label: frontField.Label,
                    type: "number",
                    fieldSettings: {
                        min: frontField.MinValue,
                        max: frontField.MaxValue,
                        step: 1,
                    },
                    valueSources: ["value"],
                    preferWidgets: ["integer"],
                    tooltip: frontField.Description,
                },
            ];
        case "Bool":
        case "Alert":
            return [
                frontField.Fieldname,
                {
                    label: frontField.Label,
                    type: "select",
                    operators: ["select_equals", "is_null", "is_not_null"],
                    tooltip: frontField.Description,
                    valueSources: ["value"],
                    fieldSettings: {
                        listValues: [
                            { value: true, title: "true" },
                            { value: false, title: "false" },
                        ],
                    },
                },
            ];
        case "Lookup":
            return [
                frontField.Fieldname,
                {
                    label: frontField.Label,
                    type: "select",
                    operators: [
                        "select_equals",
                        "select_not_equals",
                        "is_null",
                        "is_not_null",
                    ],
                    tooltip: frontField.Description,
                    valueSources: ["value"],
                    fieldSettings: {
                        asyncFetch: async search => {
                            const searchIsGuid = regexGuid.test(search);
                            let result;
                            if (!searchIsGuid) {
                                result = await fetchData(
                                    frontField.Lookup,
                                    token,
                                    "Select",
                                    null,
                                    "",
                                    search ? search : ""
                                );
                                result = result.data.map(e => ({
                                    value: e.ObjectID,
                                    title: e[frontField.LookupValueField],
                                    renderTitle: {
                                        primary: e[frontField.LookupValueField],
                                        secondary:
                                            e[frontField.LookupSecondAttribute],
                                        tertiary:
                                            e[frontField.LookupThirdAttribute]
                                                ?.Value,
                                    },
                                }));
                            } else {
                                result = await fetchData(
                                    frontField.Lookup,
                                    token,
                                    "ID",
                                    search
                                );
                                result = [
                                    {
                                        value: result.data.ID,
                                        title: result.data[
                                            frontField.LookupValueField
                                        ],
                                        renderTitle: {
                                            primary:
                                                result.data[
                                                    frontField.LookupValueField
                                                ],
                                            secondary:
                                                result.data[
                                                    frontField
                                                        .LookupSecondAttribute
                                                ],
                                            tertiary:
                                                result.data[
                                                    frontField
                                                        .LookupThirdAttribute
                                                ]?.Value,
                                        },
                                    },
                                ];
                            }
                            return { values: result };
                        },

                        useAsyncSearch: true,
                    },
                    widgets: {
                        select: {
                            widgetProps: {
                                customProps: {
                                    width: "320px",
                                    filterOptions: (options, state) => {
                                        if (
                                            Boolean(
                                                frontField.LookupSecondAttribute
                                            )
                                        ) {
                                            options.filter(option =>
                                                option.renderTitle?.secondary
                                                    .toLowerCase()
                                                    .includes(
                                                        state.inputValue.toLowerCase()
                                                    )
                                            );
                                        }
                                        return options;
                                    },
                                    renderOption: (props, option) => (
                                        <ListItem
                                            sx={{ padding: 1, margin: 0 }}
                                            {...props}
                                            key={option.value}
                                        >
                                            {Boolean(
                                                frontField.LookupThirdAttribute
                                            ) && (
                                                <Box
                                                    sx={{
                                                        mr: 2,
                                                        width: "80px",
                                                    }}
                                                >
                                                    {option.renderTitle
                                                        ?.tertiary && (
                                                        <Chip
                                                            label={
                                                                option
                                                                    .renderTitle
                                                                    ?.tertiary
                                                            }
                                                            size="small"
                                                            sx={{
                                                                width: "80px",
                                                                borderRadius: 3,
                                                            }}
                                                        />
                                                    )}
                                                </Box>
                                            )}
                                            <ListItemText
                                                sx={{
                                                    margin: 0,
                                                    padding: 0,
                                                }}
                                                primary={
                                                    option.renderTitle?.primary
                                                }
                                                secondary={
                                                    option.renderTitle
                                                        ?.secondary
                                                }
                                            />
                                        </ListItem>
                                    ),
                                },
                            },
                        },
                    },
                },
            ];
        case "Date":
            return [
                frontField.Fieldname,
                {
                    valueSources: ["value"],
                    label: frontField.Label,
                    type: "date",
                    tooltip: frontField.Description,
                    widgets: {
                        date: {
                            dateFormat: getDateFormatFromBrowser(),
                        },
                    },
                },
            ];
        case "Point":
            return [
                frontField.Fieldname,
                {
                    valueSources: ["value"],
                    label: frontField.Label,
                    type: "number",
                    tooltip: frontField.Description,
                },
            ];
        case "DateTime":
            return [
                frontField.Fieldname,
                {
                    valueSources: ["value"],
                    label: frontField.Label,
                    type: "datetime",
                    tooltip: frontField.Description,
                    widgets: {
                        datetime: {
                            dateFormat: getDateFormatFromBrowser(),
                            timeFormat: "HH:mm:ss",
                        },
                    },
                },
            ];
        default:
            return [
                frontField.Fieldname,
                { valueSources: ["value"], label: frontField.Label },
            ];
    }
};

const queryValue = {
    id: QbUtils.uuid(),
    type: "group",
    children1: {
        [QbUtils.uuid()]: {
            type: "rule",
            properties: {
                field: null,
                operator: null,
                value: [],
                valueSrc: [],
            },
        },
    },
    properties: {
        field: "StationSGWWellConstruction",
        operator: null,
        value: [],
        valueSrc: [],
    },
};

/** Part of StepQueryBuilder: Defines the set of rules applied to a specfic entity */
const QueryBuilder = ({
    EntityType,
    onChange = () => {
        /* In the form, it will call setValue() method of RHF to set values of queryString and queryJSON fields */
    },
    defaultValue,
}) => {
    if (!Boolean(EntityType)) {
        throw Error("No EntityType provided");
    }
    const locale = useSelector(state => state.i18n.locale);

    const [label, setLabel] = useState(undefined);
    const token = useSelector(state => state.auth.Token);

    const [isLoading, setIsLoading] = useState(true);
    const axiosConfig = useAxiosConfig();
    const [selectedUnit, setSelectedUnit] = useState(() => (typeof defaultValue?.Unit === 'string' ? defaultValue.Unit : ""));
    const [numberWithUnitVisible, setNumberWithUnitVisible] = useState(false);

    /** State of the config of the entire query builder */
    const [config, setConfig] = useState({
        ...MuiConfig,
    });
    const [tree, setTree] = useState();

    const safeDefaultValue = React.useMemo(() => {
        if (!defaultValue) return undefined;
        try {
            return JSON.parse(JSON.stringify(defaultValue));
        } catch {
            return defaultValue;
        }
    }, [defaultValue]);

    useEffect(() => {
        if (config.fields) {
            if (
                Boolean(defaultValue?.QueryJSON) &&
                Boolean(defaultValue?.QueryString) &&
                safeDefaultValue?.QueryJSONFormatted
            ) {
                setTree(
                    QbUtils.checkTree(
                        QbUtils.loadFromJsonLogic(
                            JSON.parse(defaultValue.QueryJSONFormatted).logic,
                            config
                        ),
                        config
                    )
                );
            } else {
                setTree(
                    QbUtils.checkTree(QbUtils.loadTree(queryValue), config)
                );
            }

            setSelectedUnit(u => u || (typeof safeDefaultValue?.Unit === 'string' ? safeDefaultValue.Unit : ""));
            setIsLoading(false);
        }
        // eslint-disable-next-line
    }, [config]);

    useEffect(() => {
        let isSubscribed = true;
        let url = `/grid/${EntityType}`;
        const language = languagesOptions.find(e => e.value === locale);
        const fetch = async () => {
            const response = await Axios.get(url, axiosConfig);
            let unitOptions = [];
            try {
                const unitsResp = await Axios.get(`/Ref_Unit/select?Category=7&limit=false`, axiosConfig);
                unitOptions = (unitsResp.data || []).map(u => u.Value).filter(Boolean);
            } catch (e) {
                console.warn('Failed to fetch units', e);
            }
            const initialUnit = typeof safeDefaultValue?.Unit === 'string' ? safeDefaultValue.Unit : '';
            if (initialUnit && !unitOptions.includes(initialUnit)) {
                unitOptions = [...unitOptions, initialUnit];
            }
            const fields = response.data?.Fields?.sort(
                (a, b) => a?.DisplayOrder - b?.DisplayOrder
            )
                ?.filter(e => e.FieldQueryable)
                ?.map(e => frontFieldToQueryField(e, token));
            if (isSubscribed) {
                setConfig(p => {
                    for(var i=0; i<fields.length; i++){
                        if(fields[i][0]==="ResultText"){
                            fields.splice(i,1)
                        }
                    }
                    const idx = fields.findIndex(f => f[0] === 'Result');
                    if (idx > -1) {
                        const original = fields[idx][1];
                        // merged unit options already include initialUnit if needed
                        const mergedUnitOptions = unitOptions;
                        fields[idx][1] = {
                            ...original,
                            preferWidgets: ['numberWithUnit'],
                            fieldSettings: {
                                ...(original.fieldSettings || {}),
                                unitOptions: mergedUnitOptions
                            },
                            widgets: {
                                ...(original.widgets || {}),
                                numberWithUnit: { widgetProps: { customProps: { unitOptions: mergedUnitOptions } } }
                            }
                        };
                    }
                    const translated = QBWidgetsTranslator(p.widgets, locale);
                    const numberOperators = (p.types?.number?.widgets?.number?.operators) || ['equal','not_equal','less','less_or_equal','greater','greater_or_equal','between','not_between','is_null','is_not_null'];
                    return {
                        ...p,
                        fields: Object.fromEntries(new Map(fields)),
                        settings: {
                            ...p.settings,
                            customFieldSelectProps: {
                                showSearch: true,
                            },
                            locale: {
                                material: language.Material,
                            },
                            theme: {
                                mui: muiTheme,
                            },
                            fieldPlaceholder: t(
                                "packages.reactAwesomeQueryBuilder.fieldPlaceholder"
                            ),
                            valuePlaceholder: t(
                                "packages.reactAwesomeQueryBuilder.valuePlaceholder"
                            ),
                            funcPlaceholder: t(
                                "packages.reactAwesomeQueryBuilder.funcPlaceholder"
                            ),
                            operatorPlaceholder: t(
                                "packages.reactAwesomeQueryBuilder.operatorPlaceholder"
                            ),
                            ...QBLocalizationTranslator,
                        },
                        operators: {
                            ...p.operators,
                            ...QBOperatorsTranslator(p.operators),
                        },
                        conjunctions: {
                            ...p.conjunctions,
                            ...QBConjunctionsTranslator(p.conjunctions),
                        },
                        widgets: {
                            ...p.widgets,
                            ...translated,
                            numberWithUnit: {
                                type: 'number',
                                valueSrc: 'value',
                                factory: widgetProps => (
                                    <NumberWithUnit
                                        {...widgetProps}
                                        currentUnit={selectedUnit}
                                        onUnitChange={setSelectedUnit}
                                        onVisibilityChange={setNumberWithUnitVisible}
                                    />
                                ),
                                formatValue: v => v
                            }
                        },
                        types: {
                            ...p.types,
                            number: {
                                ...(p.types?.number || {}),
                                widgets: {
                                    ...(p.types?.number?.widgets || {}),
                                    numberWithUnit: { operators: numberOperators }
                                }
                            }
                        }
                    };
                });
                setLabel(response.data.Label);
            }
        };
        fetch();

        return () => (isSubscribed = false);
    }, [axiosConfig, EntityType, locale, token, safeDefaultValue]);

    const renderBuilder = useCallback(
        ({ ...props }) => (
            <div
                className="query-builder-container"
                style={{ padding: "10px" }}
            >
                <div className="query-builder">
                    <Builder {...props} />
                </div>
            </div>
        ),
        []
    );
    const handleChange = useCallback(
        (immutableTree, config) => {
            const queryString = JSON.stringify(
                QbUtils.spelFormat(immutableTree, config)
            );
            const queryJSON = JSON.stringify(
                QbUtils.jsonLogicFormat(immutableTree, config)
            );
            onChange(queryString, queryJSON, selectedUnit, { numberWithUnitVisible });
            setTree(immutableTree);
        },
        [onChange, selectedUnit, numberWithUnitVisible]
    );

    useEffect(() => {
        if (tree && config) {
            const queryString = JSON.stringify(QbUtils.spelFormat(tree, config));
            const queryJSON = JSON.stringify(QbUtils.jsonLogicFormat(tree, config));
            onChange(queryString, queryJSON, selectedUnit, { numberWithUnitVisible });
        }
    }, [selectedUnit, numberWithUnitVisible]);

    return isLoading ? (
        <ScreenLoading />
    ) : (
        <div>
            <Typography
                sx={{ flex: "1 1 100%" }}
                variant="h6"
                id="tableTitle"
                component="div"
            >
                {label}
            </Typography>
            <Query
                //sx={{ opacity: "1 !important" }}
                {...config}
                value={tree}
                onChange={handleChange}
                renderBuilder={renderBuilder}
            />
        </div>
    );
};

export default QueryBuilder;


/** Step of a FormStepper: Defines the set of rules applied to one or several entities selected in the previous step */
export const StepQueryBuilder = ({ fieldName }) => {
    const methods = useFormContext();
    const { watch, setValue, formState, trigger, getValues } = methods;
    const entities = watch(fieldName);
    // const token = useSelector(state => state.auth.Token);

    const onChange = useCallback(
        (string, state, entity, unit, meta) => {
            setValue(`${fieldName}.${entity}.QueryString`, string);
            setValue(`${fieldName}.${entity}.QueryJSON`, state);
            setValue(`${fieldName}.${entity}.Unit`, unit || "");
            setValue(`${fieldName}.${entity}.__Meta`, meta || {});
        },
        [setValue, fieldName]
    );

    return (
        <Grid item xs={12}>
            {Object.entries(entities)
                .sort((a, b) => {
                    return a[1].Order - b[1].Order;
                })
                .map(([key, value], i) => {
                    const queryStringPath = `${fieldName}.${key}.QueryString`;
                    const queryJSONPath = `${fieldName}.${key}.QueryJSON`;
                    const unitPath = `${fieldName}.${key}.Unit`;
                    const queryStringVal = watch(queryStringPath);
                    const unitVal = watch(unitPath);

                    const metaPath = `${fieldName}.${key}.__Meta`;
                    const metaVal = watch(metaPath) || {};
                    const numberWithUnitVisible = !!metaVal.numberWithUnitVisible;

                    const queryJSONVal = watch(queryJSONPath);
                    const queryStringErr = formState.errors[fieldName]?.[key]?.QueryString?.message;
                    const unitErr = formState.errors[fieldName]?.[key]?.Unit?.message;
                    const queryJSONErr = formState.errors[fieldName]?.[key]?.QueryJSON?.message;
                    const error = queryStringErr || unitErr || queryJSONErr;

                    const usesResultField = (() => {
                        try {
                            if (!queryJSONVal) return false;
                            const parsed = typeof queryJSONVal === 'string' ? JSON.parse(queryJSONVal) : queryJSONVal;
                            const logic = parsed?.logic;
                            const scan = node => {
                                if (!node) return false;
                                if (Array.isArray(node)) return node.some(scan);
                                if (typeof node === 'object') {
                                    if (node.var && String(node.var).toLowerCase() === 'result') return true;
                                    return Object.values(node).some(scan);
                                }
                                return false;
                            };
                            const usesField = scan(logic);
                            const usesResultByString = typeof queryStringVal === 'string' && /\bResult\b/i.test(queryStringVal);
                            return usesField || usesResultByString;
                        } catch {
                            return typeof queryStringVal === 'string' && /\bResult\b/i.test(queryStringVal);
                        }
                    })();

                    const resultHasNumericValue = (() => {
                        try {
                            const parsed = typeof queryJSONVal === 'string' ? JSON.parse(queryJSONVal) : queryJSONVal;
                            const logic = parsed?.logic;
                            const extractVal = a => {
                                if (a === null || a === undefined) return null;
                                if (typeof a !== 'object') return a;
                                if ('var' in a) return null; // field ref
                                if ('value' in a) return a.value;
                                return a;
                            };
                            const isNonEmpty = v => {
                                const val = extractVal(v);
                                if (val === null || val === undefined) return false;
                                if (Array.isArray(val)) return val.length > 0;
                                if (typeof val === 'string') return val.trim() !== '';
                                if (typeof val === 'number') return !Number.isNaN(val);
                                return true;
                            };
                            const containsResultVar = node => {
                                if (!node) return false;
                                if (Array.isArray(node)) return node.some(containsResultVar);
                                if (typeof node === 'object') {
                                    if (node.var && String(node.var).toLowerCase() === 'result') return true;
                                    return Object.values(node).some(containsResultVar);
                                }
                                return false;
                            };
                            const scan = node => {
                                if (!node) return false;
                                if (Array.isArray(node)) return node.some(scan);
                                if (typeof node === 'object') {
                                    const keys = Object.keys(node);
                                    if (keys.length === 1) {
                                        const op = keys[0];
                                        const args = node[op];
                                        if (op === 'and' || op === 'or') return Array.isArray(args) && args.some(scan);
                                        // RAQB ternary '<=' form: [from, {var:Result}, to]
                                        if (op === '<=') {
                                            if (!Array.isArray(args)) return false;
                                            if (args.length === 3) {
                                                const [from, mid, to] = args;
                                                const isResultMid = mid && typeof mid === 'object' && 'var' in mid && String(mid.var || '').toLowerCase() === 'result';
                                                return isResultMid && isNonEmpty(from) && isNonEmpty(to);
                                            }
                                        }
                                        if (op === 'between' || op === 'not_between') {
                                            if (!Array.isArray(args)) return false;
                                            const values = args.filter(a => !(a && typeof a === 'object' && 'var' in a));
                                            const hasTwoBounds = values.length >= 2 && isNonEmpty(values[0]) && isNonEmpty(values[1]);
                                            const targetsResult = args.some(a => a && typeof a === 'object' && String(a.var || '').toLowerCase() === 'result') || containsResultVar(node);
                                            return targetsResult && hasTwoBounds;
                                        }
                                        const binaryOps = ['==','!=','>','>=','<','<=','like','not_like','starts_with','ends_with','in','not_in'];
                                        if (binaryOps.includes(op)) {
                                            if (!Array.isArray(args)) return false;
                                            // handle normal 2-arg form
                                            if (args.length >= 2) {
                                                const lhs = args.find(a => a && typeof a === 'object' && 'var' in a);
                                                const rhs = args.find(a => !(a && typeof a === 'object' && 'var' in a));
                                                const isResult = lhs && String(lhs.var || '').toLowerCase() === 'result';
                                                if (isResult && isNonEmpty(rhs)) return true;
                                            }
                                        }
                                        return Object.values(node).some(scan);
                                    }
                                    return Object.values(node).some(scan);
                                }
                                return false;
                            };
                            return scan(logic);
                        } catch {
                            return typeof queryStringVal === 'string' && /\bResult\b[^\d]*\d/.test(queryStringVal);
                        }
                    })();

                    return (
                        <Box
                            key={"Query" + key + i}
                            sx={
                                error && {
                                    p: 1,
                                    mb: 1,
                                    border: "1px solid red",
                                    borderRadius: "6px",
                                }
                            }
                        >
                            <QueryBuilder
                                EntityType={key}
                                onChange={(string, state, unit, meta) => {
                                    onChange(string, state, key, unit, meta);

                                    // Defer triggers to ensure meta.visibility is stored before validation runs
                                    setTimeout(() => {
                                        if (!meta?.numberWithUnitVisible) {
                                            // Clear errors that might have been set while the unit widget was visible
                                            methods.clearErrors(unitPath);
                                            methods.clearErrors(queryStringPath);
                                        }
                                        // Trigger validations using the updated flag first
                                        trigger(queryJSONPath);
                                        trigger(queryStringPath);
                                        if (meta?.numberWithUnitVisible) {
                                            trigger(unitPath); // require unit only when NumberWithUnit is visible
                                        }
                                    }, 0);

                                    // Avoid showing required error immediately on field selection.
                                    // Trigger validation appropriately per field
                                    const hasAnyValue = (() => {
                                        try {
                                            const parsed = typeof state === 'string' ? JSON.parse(state) : state;
                                            const logic = parsed?.logic;
                                            const isNonEmpty = v => v !== null && v !== undefined && !(typeof v === 'string' && v.trim() === '') && !(Array.isArray(v) && v.length === 0);
                                            const scan = node => {
                                                if (!node) return false;
                                                if (Array.isArray(node)) return node.some(scan);
                                                if (typeof node === 'object') {
                                                    const keys = Object.keys(node);
                                                    if (keys.length === 1) {
                                                        const op = keys[0];
                                                        const args = node[op];
                                                        if (op === 'and' || op === 'or') return Array.isArray(args) && args.some(scan);
                                                        if (op === 'between' || op === 'not_between') {
                                                            if (!Array.isArray(args) || args.length !== 3) return false;
                                                            const [, v1, v2] = args;
                                                            return isNonEmpty(v1) && isNonEmpty(v2);
                                                        }
                                                        const binaryOps = ['==','!=','>','>=','<','<=','like','not_like','starts_with','ends_with','in','not_in'];
                                                        if (binaryOps.includes(op)) {
                                                            if (!Array.isArray(args) || args.length < 2) return false;
                                                            const valueSide = args[1];
                                                            return isNonEmpty(valueSide);
                                                        }
                                                        return Object.values(node).some(scan);
                                                    }
                                                    return Object.values(node).some(scan);
                                                }
                                                return isNonEmpty(node);
                                            };
                                            return scan(logic);
                                        } catch {
                                            return Boolean(string);
                                        }
                                    })();

                                    // Check if current change targets Result field
                                    const usesResultFieldNow = (() => {
                                        try {
                                            const parsed = typeof state === 'string' ? JSON.parse(state) : state;
                                            const logic = parsed?.logic;
                                            const scan = node => {
                                                if (!node) return false;
                                                if (Array.isArray(node)) return node.some(scan);
                                                if (typeof node === 'object') {
                                                    if (node.var && String(node.var).toLowerCase() === 'result') return true;
                                                    return Object.values(node).some(scan);
                                                }
                                                return false;
                                            };
                                            return scan(logic);
                                        } catch {
                                            return /\bResult\b/i.test(String(string));
                                        }
                                    })();

                                    // Additional immediate revalidation for Result using updated meta
                                    if (usesResultFieldNow) {
                                        setTimeout(() => {
                                            trigger(queryStringPath);
                                            trigger(queryJSONPath);
                                            if (meta?.numberWithUnitVisible) {
                                                trigger(unitPath);
                                            } else {
                                                methods.clearErrors(unitPath);
                                                methods.clearErrors(queryStringPath);
                                            }
                                        }, 0);
                                    } else if (hasAnyValue) {
                                        setTimeout(() => {
                                            trigger(queryStringPath);
                                            trigger(queryJSONPath);
                                        }, 0);
                                    }
                                }}
                                defaultValue={value}
                            />
                            <HiddenField
                                fieldName={queryJSONPath}
                                validation={{
                                    validate: v => {
                                        const metaNow = getValues(metaPath) || {};
                                        const numberWithUnitVisibleNow = !!metaNow.numberWithUnitVisible;
                                        if (usesResultField && !numberWithUnitVisibleNow) return true;
                                        if (!usesResultField) {
                                            return v ? true : t("input.validation.required");
                                        }
                                        try {
                                            const parsed = typeof v === 'string' ? JSON.parse(v) : v;
                                            const logic = parsed?.logic;
                                            const extractVal = a => {
                                                if (a === null || a === undefined) return null;
                                                if (typeof a !== 'object') return a;
                                                if ('var' in a) return null;
                                                if ('value' in a) return a.value;
                                                return a;
                                            };
                                            const isNonEmpty = val => {
                                                const vv = extractVal(val);
                                                if (vv === null || vv === undefined) return false;
                                                if (Array.isArray(vv)) return vv.length > 0;
                                                if (typeof vv === 'string') return vv.trim() !== '';
                                                if (typeof vv === 'number') return !Number.isNaN(vv);
                                                return true;
                                            };
                                            const hasValue = (() => {
                                                const scan = node => {
                                                    if (!node) return false;
                                                    if (Array.isArray(node)) return node.some(scan);
                                                    if (typeof node === 'object') {
                                                        const keys = Object.keys(node);
                                                        if (keys.length === 1) {
                                                            const op = keys[0];
                                                            const args = node[op];
                                                            if (op === 'and' || op === 'or') return Array.isArray(args) && args.some(scan);
                                                            if (op === '<=') {
                                                                if (!Array.isArray(args)) return false;
                                                                if (args.length === 3) {
                                                                    const [from, mid, to] = args;
                                                                    const isResultMid = mid && typeof mid === 'object' && 'var' in mid && String(mid.var || '').toLowerCase() === 'result';
                                                                    return isResultMid && isNonEmpty(from) && isNonEmpty(to);
                                                                }
                                                            }
                                                            if (op === 'between' || op === 'not_between') {
                                                                if (!Array.isArray(args)) return false;
                                                                const values = args.filter(a => !(a && typeof a === 'object' && 'var' in a));
                                                                return values.length >= 2 && isNonEmpty(values[0]) && isNonEmpty(values[1]);
                                                            }
                                                            const binaryOps = ['==','!=','>','>=','<','<=','like','not_like','starts_with','ends_with','in','not_in'];
                                                            if (binaryOps.includes(op)) {
                                                                if (!Array.isArray(args)) return false;
                                                                if (args.length >= 2) {
                                                                    const rhs = args.find(a => !(a && typeof a === 'object' && 'var' in a));
                                                                    return isNonEmpty(rhs);
                                                                }
                                                            }
                                                            return Object.values(node).some(scan);
                                                        }
                                                        return Object.values(node).some(scan);
                                                    }
                                                    return isNonEmpty(node);
                                                };
                                                return scan(logic);
                                            })();
                                            return hasValue ? true : t("input.validation.required");
                                        } catch {
                                            return v ? true : t("input.validation.required");
                                        }
                                    }
                                }}
                            />
                            <HiddenField
                                fieldName={queryStringPath}
                                validation={{
                                    validate: v => {
                                        if (usesResultField && !numberWithUnitVisible) return true;
                                        if (!v) return t("input.validation.required");
                                        if (usesResultField && !resultHasNumericValue) return t("input.validation.required");
                                        return true;
                                    },
                                }}
                            />
                            <HiddenField
                                fieldName={unitPath}
                                validation={{
                                    validate: v => {
                                        if (usesResultField) {
                                            if (!numberWithUnitVisible) return true;
                                            if (v && !resultHasNumericValue) return t("input.validation.required");
                                            if (resultHasNumericValue) return v ? true : t("input.validation.required");
                                        }
                                        return true;
                                    },
                                }}
                            />
                            <FormHelperText error={true} sx={{ ml: 2 }}>
                                {error}
                            </FormHelperText>
                            {i !== entities.length - 1 && !error && (
                                <Divider sx={{ marginBottom: 1 }} />
                            )}
                        </Box>
                    );
                })}
        </Grid>
    );
};

//===================== Query builder translators =========================

const QBConjunctionsTranslator = object => {
    return {
        AND: {
            ...object.AND,
            label: t("packages.reactAwesomeQueryBuilder.and"),
        },
        OR: {
            ...object.OR,
            label: t("packages.reactAwesomeQueryBuilder.or"),
        },
    };
};

const QBOperatorsTranslator = object => {
    return {
        like: {
            ...object.like,
            label: (
                <Translate value={"packages.reactAwesomeQueryBuilder.like"} />
            ),
        },
        not_like: {
            ...object.not_like,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.not_like"}
                />
            ),
        },
        starts_with: {
            ...object.starts_with,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.starts_with"}
                />
            ),
        },
        ends_with: {
            ...object.ends_with,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.ends_with"}
                />
            ),
        },
        between: {
            ...object.between,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.between"}
                />
            ),
            textSeparators: [
                null,
                <Translate value={"packages.reactAwesomeQueryBuilder.and"} />,
            ],
        },
        not_between: {
            ...object.not_between,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.not_between"}
                />
            ),
            textSeparators: [
                null,
                <Translate value={"packages.reactAwesomeQueryBuilder.and"} />,
            ],
        },
        is_null: {
            ...object.is_null,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.is_null"}
                />
            ),
        },
        is_not_null: {
            ...object.is_not_null,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.is_not_null"}
                />
            ),
        },
        is_empty: {
            ...object.is_empty,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.is_empty"}
                />
            ),
        },
        is_not_empty: {
            ...object.is_not_empty,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.is_not_empty"}
                />
            ),
        },
        select_any_in: {
            ...object.select_any_in,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.select_any_in"}
                />
            ),
        },
        select_not_any_in: {
            ...object.select_not_any_in,
            label: (
                <Translate
                    value={
                        "packages.reactAwesomeQueryBuilder.select_not_any_in"
                    }
                />
            ),
        },
        proximity: {
            ...object.proximity,
            label: (
                <Translate
                    value={"packages.reactAwesomeQueryBuilder.proximity"}
                />
            ),
        },
    };
};

const QBLocalizationTranslator = {
    valueLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.valueLabel"} />
    ),

    fieldLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.fieldLabel"} />
    ),
    operatorLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.operatorLabel"} />
    ),
    funcLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.funcLabel"} />
    ),

    lockLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.lockLabel"} />
    ),
    lockedLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.lockedLabel"} />
    ),
    deleteLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.deleteLabel"} />
    ),
    delGroupLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.delGroupLabel"} />
    ),
    addGroupLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.addGroupLabel"} />
    ),
    addRuleLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.addRuleLabel"} />
    ),
    addSubRuleLabel: (
        <Translate
            value={"packages.reactAwesomeQueryBuilder.addSubRuleLabel"}
        />
    ),
    notLabel: (
        <Translate value={"packages.reactAwesomeQueryBuilder.notLabel"} />
    ),
    valueSourcesPopupTitle: (
        <Translate
            value={"packages.reactAwesomeQueryBuilder.valueSourcesPopupTitle"}
        />
    ),
    removeRuleConfirmOptions: {
        title: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeRuleConfirmOptions.title"
                }
            />
        ),
        okText: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeRuleConfirmOptions.okText"
                }
            />
        ),
        okType: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeRuleConfirmOptions.okType"
                }
            />
        ),
        cancelText: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeRuleConfirmOptions.cancelText"
                }
            />
        ),
    },
    removeGroupConfirmOptions: {
        title: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeGroupConfirmOptions.title"
                }
            />
        ),
        okText: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeGroupConfirmOptions.okText"
                }
            />
        ),
        okType: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeGroupConfirmOptions.okType"
                }
            />
        ),
        cancelText: (
            <Translate
                value={
                    "packages.reactAwesomeQueryBuilder.removeGroupConfirmOptions.cancelText"
                }
            />
        ),
    },
};

const QBWidgetsTranslator = object => {
    const getDateFormatFromBrowser = () => {
        return navigator.language.startsWith('en') ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    };

    const dateFormat = getDateFormatFromBrowser();

    return {
        text: {
            ...object.text,
            valuePlaceholder: t("packages.reactAwesomeQueryBuilder.enterText"),
        },
        textarea: {
            ...object.textarea,
            valuePlaceholder: t("packages.reactAwesomeQueryBuilder.enterText"),
        },
        number: {
            ...object.number,
            valuePlaceholder: t(
                "packages.reactAwesomeQueryBuilder.enterNumber"
            ),
            valueLabels: [
                {
                    label: t(
                        "packages.reactAwesomeQueryBuilder.enterNumberFrom"
                    ),
                    placeholder: t(
                        "packages.reactAwesomeQueryBuilder.enterNumberFrom"
                    ),
                },
                {
                    label: t("packages.reactAwesomeQueryBuilder.enterNumberTo"),
                    placeholder: t(
                        "packages.reactAwesomeQueryBuilder.enterNumberTo"
                    ),
                },
            ],
        },
        select: {
            ...object.select,
            valuePlaceholder: t(
                "packages.reactAwesomeQueryBuilder.selectValue"
            ),
        },
        multiselect: {
            ...object.multiselect,
            valuePlaceholder: t(
                "packages.reactAwesomeQueryBuilder.selectValues"
            ),
        },
        date: {
            ...object.date,
            dateFormat: dateFormat,
            valuePlaceholder: t("packages.reactAwesomeQueryBuilder.enterDate"),
        },
        datetime: {
            ...object.datetime,
            dateFormat: dateFormat,
            valuePlaceholder: t("packages.reactAwesomeQueryBuilder.enterDate"),
        },
    };
};

const NumberWithUnit = (props) => {
    const { value, setValue, placeholder, onUnitChange, currentUnit, onVisibilityChange } = props;
    const operator = props.operator;
    const fieldKey = props.field;
    const fieldDef = props.config?.fields?.[fieldKey];
    let unitOptions = fieldDef?.fieldSettings?.unitOptions;
    if (!Array.isArray(unitOptions))
        unitOptions = [];
    
    unitOptions = Array.from(new Set(unitOptions.map(u => (typeof u === 'string' ? u : (u?.Value || u?.title || u?.value || ''))).filter(Boolean)));
    if (currentUnit && currentUnit !== '' && !unitOptions.includes(currentUnit)) {
        unitOptions = [...unitOptions, currentUnit];
    }
    const [unit, setUnit] = useState(currentUnit || "");
    const [inputUnit, setInputUnit] = useState(currentUnit || "");
    useEffect(() => {
        if (currentUnit && currentUnit !== unit) {
            setUnit(currentUnit);
            setInputUnit(currentUnit);
        }
        if (!currentUnit && unit) {
            setUnit("");
            setInputUnit("");
        }
    }, [currentUnit]);
    const step = fieldDef?.fieldSettings?.step ?? 1;

    const isBetweenOp = operator === 'between' || operator === 'not_between';
    const isSecondValue = isBetweenOp && /to/i.test(String(placeholder || ''));
    const shouldShowUnit = (operator !== 'is_null' && operator !== 'is_not_null') && (!isBetweenOp || isSecondValue);

    useEffect(() => {
        if (typeof onVisibilityChange === 'function') {
            onVisibilityChange(shouldShowUnit);
        }
        return () => {
            if (typeof onVisibilityChange === 'function') {
                onVisibilityChange(false);
            }
        };
    }, [onVisibilityChange, shouldShowUnit]);

    return (
        <Box className="number-with-unit-range" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
            <TextField
                type="number"
                size="small"
                value={value ?? ''}
                placeholder={t("packages.reactAwesomeQueryBuilder.enterNumber")}
                onChange={e => {
                    const v = e.target.value;
                    setValue(v === '' ? null : Number(v));
                }}
                inputProps={{ step }}
                sx={{ width: 160, flex: '0 0 auto' }}
                variant="standard"
            />
            {shouldShowUnit && (
                <Autocomplete
                    options={unitOptions}
                    freeSolo
                    size="small"
                    value={unit}
                    inputValue={inputUnit}
                    isOptionEqualToValue={(opt, val) => opt === val}
                    getOptionLabel={opt => opt}
                    filterOptions={(options, params) => {
                        const filtered = options.filter(o => o.toLowerCase().includes(params.inputValue.toLowerCase()));
                        if (params.inputValue && !filtered.includes(params.inputValue)) {
                            filtered.push(params.inputValue);
                        }
                        return filtered;
                    }}
                    onChange={(_, nv) => {
                        if (nv === null) {
                            setUnit("");
                            setInputUnit("");
                            onUnitChange && onUnitChange("");
                            return;
                        }
                        const newUnit = String(nv);
                        setUnit(newUnit);
                        setInputUnit(newUnit);
                        onUnitChange && onUnitChange(newUnit);
                    }}
                    onInputChange={(_, nv, reason) => {
                        if (reason === 'input') {
                            setInputUnit(nv);
                        } else if (reason === 'clear') {
                            setInputUnit("");
                            setUnit("");
                            onUnitChange && onUnitChange("");
                        }
                    }}
                    renderInput={params => (
                        <TextField
                            {...params}
                            // Removed label to match height/alignment with the number input
                            label={undefined}
                            size="small"
                            variant="standard"
                            placeholder={unitOptions.length ? t("common.SelectUnit") : 'No units'}
                            InputLabelProps={{ shrink: false }}
                            onBlur={() => {
                                if (inputUnit !== unit) {
                                    setUnit(inputUnit);
                                    onUnitChange && onUnitChange(inputUnit);
                                }
                            }}
                        />
                    )}
                    PopperProps={{ style: { zIndex: 1600 } }}
                    slotProps={{
                        popper: { placement: 'bottom-start', modifiers: [{ name: 'flip', enabled: false }] }
                    }}
                    ListboxProps={{ style: { maxHeight: 320 } }}
                    sx={{ width: 160, flex: '0 0 auto' }}
                />
            )}
        </Box>
    );
};
